export type PatientInsuranceCompanyOption = {
    value: string;
    labelZh: string;
    labelEn: string;
};

export const PATIENT_INSURANCE_COMPANY_OTHER = 'other';

export const PATIENT_INSURANCE_COMPANIES: PatientInsuranceCompanyOption[] = [
    { value: 'aia', labelZh: '友邦保險 (AIA)', labelEn: 'AIA' },
    { value: 'prudential', labelZh: '保誠保險 (Prudential)', labelEn: 'Prudential' },
    { value: 'manulife', labelZh: '宏利保險 (Manulife)', labelEn: 'Manulife' },
    { value: 'axa', labelZh: '安盛保險 (AXA)', labelEn: 'AXA' },
    { value: 'bupa', labelZh: '保柏 (Bupa)', labelEn: 'Bupa' },
    { value: 'cigna', labelZh: '信諾 (Cigna)', labelEn: 'Cigna' },
    { value: 'hsbc', labelZh: '滙豐保險 (HSBC Life)', labelEn: 'HSBC Life' },
    { value: 'hang_seng', labelZh: '恒生保險 (Hang Seng)', labelEn: 'Hang Seng Insurance' },
    { value: 'blue_cross', labelZh: '藍十字 (Blue Cross)', labelEn: 'Blue Cross' },
    { value: 'boc_life', labelZh: '中銀人壽 (BOC Life)', labelEn: 'BOC Life' },
    { value: 'china_life', labelZh: '中國人壽 (China Life)', labelEn: 'China Life' },
    { value: 'sun_life', labelZh: '永明金融 (Sun Life)', labelEn: 'Sun Life' },
    { value: 'fwd', labelZh: '富衛保險 (FWD)', labelEn: 'FWD' },
    { value: 'ftlife', labelZh: '富通保險 (FTLife)', labelEn: 'FTLife' },
    { value: 'yf_life', labelZh: '萬通保險 (YF Life)', labelEn: 'YF Life' },
    { value: 'ctf_life', labelZh: '周大福人壽 (CTF Life)', labelEn: 'CTF Life' },
    { value: 'bea_life', labelZh: '東亞人壽 (BEA Life)', labelEn: 'BEA Life' },
    { value: 'dah_sing', labelZh: '大新人壽 (Dah Sing Life)', labelEn: 'Dah Sing Life' },
    { value: 'generali', labelZh: '忠意保險 (Generali)', labelEn: 'Generali' },
    { value: 'zurich', labelZh: '蘇黎世 (Zurich)', labelEn: 'Zurich' },
    { value: 'allianz', labelZh: '安聯 (Allianz)', labelEn: 'Allianz' },
    { value: 'chubb', labelZh: '安達 (Chubb)', labelEn: 'Chubb' },
    { value: 'liberty', labelZh: '利寶 (Liberty)', labelEn: 'Liberty' },
    { value: 'bowtie', labelZh: 'Bowtie', labelEn: 'Bowtie' },
    { value: 'onedegree', labelZh: 'OneDegree', labelEn: 'OneDegree' },
    { value: PATIENT_INSURANCE_COMPANY_OTHER, labelZh: '其他', labelEn: 'Other' },
];
